/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'

import { AuthBG, LOGO_LOGIN } from 'Assets'
import { AuthWrapper } from '../Modules/auth/styled'

const Wrapper = styled.div`
  background-color: #F0F2F5;
  width: 100%;
  min-height: 100vh;
  padding: 110px 0 145px;
`
const Body = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  background-image: url(${AuthBG});
  background-size: contain;
  background-position: center;
  height: 100%;
  background-repeat: no-repeat;
`

const AuthLayout = ({ children }) => (
  <Wrapper>
    <Body>
      <AuthWrapper>
        <LOGO_LOGIN />
        {children}
      </AuthWrapper>
    </Body>
  </Wrapper>
)

export default AuthLayout
